import React, { Component } from "react";
import { Redirect } from "react-router";
import InputHandler from "../../shared/javascript/InputHandler";
import { LoadingModal } from "../../shared/Components/LoadingModal";
import { Checkbox } from "../../shared/Components/Checkbox";
import { Textbox } from "../../shared/Components/Textbox";
import { DateSelector } from "../../shared/Components/DateSelector";
import { SelectBox } from "../../shared/Components/SelectBox/SelectBox";
import error_messages from "./error_messages.json";
import SubmissionHandler from "../../shared/javascript/SubmissionHandler";
import "react-datepicker/dist/react-datepicker.css";

var inputHandler = new InputHandler(error_messages);
var submissionHandler = new SubmissionHandler(error_messages);

export class Validation extends Component {
  displayName = Validation.name;
  constructor(props) {
    super(props);
    this.state = {
      user_browser: navigator.userAgent,
      endpoint: "/api/arkansas/dentalforhealth/validate",
      location: props.location,
      errors: {
        pregnancy_due_date: "",
        primary_first_name: "",
        primary_last_name: "",
        member_first_name: "",
        member_last_name: "",
        member_dob: "",
        member_address: "",
        member_city: "",
        member_state: "",
        member_zip: "",
        member_email: "",
        physician_first_name: "",
        physician_last_name: "",
        physician_phone: "",
        physician_address: "",
        physician_city: "",
        physician_state: "",
        physician_zip: "",
        default_error: ""
      },
      user_input: {
        referrals: "",
        other_referral: "",
        conditions: "",
        member_id: "",
        group_number: "",
        pregnancy_due_date: "",
        primary_first_name: "",
        primary_last_name: "",
        member_first_name: "",
        member_last_name: "",
        member_dob: "",
        member_address: "",
        member_city: "",
        member_state: "",
        member_zip: "",
        member_home_phone: "",
        member_cell_phone: "",
        member_email: "",
        ecc: false,
        physician_first_name: "",
        physician_last_name: "",
        physician_phone: "",
        physician_license: "",
        physician_license_state: "",
        physician_address: "",
        physician_city: "",
        physician_state: "",
        physician_zip: "",
        affirmation: false
      },
      form_is_valid: false,
      is_loading: false,
      success: false
    };
  }

  render = () => {
    const {
      location,
      errors,
      user_input,
      is_loading,
      form_is_valid,
      success
    } = this.state;

    var page = <Redirect to="/ar/dentalforhealth/prevalidate" />;
    var pregnancy = null;
    var eccDisplay = null;

    //remove ecc if member_email is empty
    if (user_input.member_email !== "") {
      eccDisplay = (
        <div className="col-md-6">
          <Checkbox
            name="ecc"
            label="Member agrees to receiving electronic communication about Dental Xtra"
            checked={user_input.ecc}
            onChange={e => inputHandler.handleCheckboxChange(e, this)}
          />
          {errors.ecc}
        </div>
      );
    } else if (user_input.member_email === "") {
      user_input.ecc = false;
    }

    if (location.success) {
      if (location.user_input.conditions.pregnancy.is_checked) {
        pregnancy = (
          <div className="col-12">
            <div>
              <DateSelector
                name="pregnancy_due_date"
                label_name="Pregnancy Due Date"
                required={true}
                selected={user_input.pregnancy_due_date}
                onChange={date =>
                  inputHandler.handleDateChange(
                    date,
                    this,
                    "pregnancy_due_date",
                    true
                  )
                }
              />
            </div>
            {errors.pregnancy_due_date}
          </div>
        );
      }

      page = (
        <div className="padding-top container">
          <h3>
            You are eligible. Please fill in the additional required information
            below.
          </h3>
          <br />
          <h2>Member Information</h2>
          <div className="row">
            {pregnancy}
            <div className="col-md-6">
              <Textbox
                name="primary_first_name"
                label_name="Primary Policy Holder"
                required={true}
                placeholder="First Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.primary_first_name}
            </div>
            <div className="col-md-6">
              <Textbox
                name="primary_last_name"
                required={true}
                placeholder="Last Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.primary_last_name}
              {errors.primary_name}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_first_name"
                label_name="Member Being Enrolled"
                required={true}
                placeholder="First Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_first_name}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_last_name"
                required={true}
                placeholder="Last Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_last_name}
              {errors.member_name}
            </div>
            <div className="col-md-6">
              <DateSelector
                name="member_dob"
                label_name="Enrolling Member Date of Birth"
                required={true}
                selected={user_input.member_dob}
                onChange={date =>
                  inputHandler.handleDateChange(date, this, "member_dob", true)
                }
              />
              {errors.member_dob}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_address"
                label_name="Member Address"
                required={true}
                placeholder="Street (Apt if applicable)"
                maxLength="50"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_address}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_city"
                label_name="City"
                required={true}
                placeholder="City"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_city}
            </div>
            <div className="col-md-6">
              <SelectBox
                name="member_state"
                type="states"
                label_name="State"
                required={true}
                onChange={e =>
                  inputHandler.handleSelectChange(e, this, "State")
                }
              />
              {errors.member_state}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_zip"
                type="text"
                label_name="ZIP"
                required={true}
                placeholder="ZIP"
                maxLength="5"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_zip}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_home_phone"
                label_name="Member Phone Number (Home)"
                type="tel"
                placeholder="(555)555-5555"
                maxLength="13"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_home_phone}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_cell_phone"
                label_name="Member Phone Number (Cell)"
                type="tel"
                placeholder="(555)555-5555"
                maxLength="13"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_cell_phone}
            </div>
            <div className="col-md-6">
              <Textbox
                name="member_email"
                label_name="Email Address"
                type="email"
                placeholder="example@address.com"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.member_email}
            </div>
            {eccDisplay}
          </div>
          <br />
          <h2>Physician Information</h2>
          <div className="row">
            <div className="col-md-6">
              <Textbox
                name="physician_first_name"
                label_name="Physician Name"
                required={true}
                placeholder="First Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_first_name}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_last_name"
                required={true}
                placeholder="Last Name"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_last_name}
              {errors.physician_name}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_phone"
                label_name="Physician Phone Number"
                required={true}
                type="tel"
                placeholder="(555)555-5555"
                maxLength="13"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_phone}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_license"
                label_name="Physician License Number"
                placeholder="ex. MD-9999"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_license}
            </div>
            <div className="col-md-6">
              <SelectBox
                name="physician_license_state"
                type="states"
                label_name="State"
                onChange={e =>
                  inputHandler.handleSelectChange(e, this, "State")
                }
              />
              {errors.physician_license_state}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_address"
                label_name="Physician Address"
                required={true}
                placeholder="Street (Suite if applicable)"
                maxLength="50"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_address}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_city"
                label_name="City"
                required={true}
                placeholder="City"
                maxLength="30"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_city}
            </div>
            <div className="col-md-6">
              <SelectBox
                name="physician_state"
                type="states"
                label_name="State"
                required={true}
                onChange={e =>
                  inputHandler.handleSelectChange(e, this, "State")
                }
              />
              {errors.physician_state}
            </div>
            <div className="col-md-6">
              <Textbox
                name="physician_zip"
                type="text"
                label_name="ZIP"
                required={true}
                placeholder="ZIP"
                maxLength="5"
                onChange={e => inputHandler.handleBasicInputChange(e, this)}
              />
              {errors.physician_zip}
            </div>
          </div>
          <div className="row">
            <div className="form-group col">
              <Checkbox
                name="affirmation"
                label="I affirm that all the information provided is correct to my knowledge and I am currently enrolled in a Dental Xtra plan."
                checked={user_input.affirmation}
                required={true}
                onChange={e => inputHandler.handleCheckboxChange(e, this)}
              />
              {errors.affirmation}
            </div>
          </div>
          <div className="form-group">
            <input
              disabled={!form_is_valid}
              type="submit"
              className="btn btn-secondary"
              onClick={e =>
                submissionHandler.BuildARValidation(this).handleSubmit(e)
              }
              value="Submit"
            />
            <div aria-hidden="true" id="required-description">
              <span aria-hidden="true" className="text-danger">
                *
              </span>
              Required field
            </div>
          </div>
          {errors.default_error}
        </div>
      );
    }

    var modal = null;
    if (is_loading) {
      modal = <LoadingModal />;
    }

    var currentRoute = window.location.href.replace(/^.*\/\/[^\/]+/, "");
    var successRoute = "/ar/dentalforhealth/success";
    if (success) {
      return (
        <Redirect
          to={{
            pathname: successRoute,
            success
          }}
        />
      );
    }
    return (
      <div>
        {page}
        {modal}
      </div>
    );
  };
}
